import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

// Containers
import PublicLayout from '../layouts/PublicLayout';
import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';

// Images
// import LogoImg from '../../assets/images/ITLogo_web.svg';

// App routes
import appRoutes from '../routes/appRoutes';
import { forgotPassword } from '../api/auth';
import ForgotPasswordModal from './ForgotPasswordModal';

const ForgotPassword = () => {
  const [isEmailSentModal, setIsEmailSentModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleForgotPasswordForm = async (formVal) => {
    try {
      await forgotPassword(formVal);
      setIsEmailSentModal(true);
    } catch (error) {
      setErrorMessage(error.data.message);
      setTimeout(() => {
        setErrorMessage('');
      }, 4500);
    }
  };

  const handleModalClose = () => {
    setIsEmailSentModal(false);
    navigate(appRoutes.login);
  };

  return (
    <PublicLayout>
      <Box width={1} mb={2}>
        <Typography variant="h3" gutterBottom>
          Forget Password
        </Typography>
        <Typography paragraph>
          A link will be sent to your email address so you can reset your password
        </Typography>
      </Box>
      <Box width={1}>
        <ForgotPasswordForm onFormSubmit={handleForgotPasswordForm} serverErrorMsg={errorMessage} />
      </Box>
      <ForgotPasswordModal open={isEmailSentModal} onClose={handleModalClose} />
    </PublicLayout>
  );
};

export default ForgotPassword;
